module.exports = __webpack_public_path__ + "static/img/cwglh5.d19e8c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cwglh5.png
// module id = zsQU
// module chunks = 1